export default __webpack_public_path__ + "static/media/(2).e552a30a.jpg";